module.exports = __webpack_public_path__ + "static/media/caret-right.d473b87c.svg";